/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { enrichedAddressGet } from "../../funcs/enrichedAddressGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetEnrichmentAddressRequest$inboundSchema,
};

export const tool$enrichedAddressGet: ToolDefinition<typeof args> = {
  name: "enriched-address-get",
  description: `Fetch enriched address suggestions. Requires a partial address. 
  
To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/profile-enrichment.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await enrichedAddressGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
